import { render } from "./ErrorSuccessMessage.vue?vue&type=template&id=6778598d&scoped=true"
import script from "./ErrorSuccessMessage.vue?vue&type=script&lang=js"
export * from "./ErrorSuccessMessage.vue?vue&type=script&lang=js"

import "./ErrorSuccessMessage.vue?vue&type=style&index=0&id=6778598d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6778598d"]])

export default __exports__